import './ldialog/src/ldialog';
import $ from 'jquery';
import dialogEvents from './l-dialog-events';

const lDialog = window.lDialog;

lDialog.messages = {
  spinning:     '<div class="dialog-loading"><p></p></div>',
  loading:      '<div class="dialog-loading"><p>Loadingâ€¦</p></div>',
  reloading:    '<p class="dialog-loading">Reloading, please wait.</p>',
  takingToCart: '<p class="dialog-loading">Taking you to your cart</p>'
};

lDialog.defaults.closeOnOverlay = false;
lDialog.defaults.content = lDialog.messages.loading;

const errorHtml = '<p class="center big">Weâ€™re sorry, an error has occurred. Please try again later</p>';

lDialog.showGeneralError = () => {
  lDialog.open({
    title: 'Uh oh!',
    content: errorHtml
  });
};

$(document).on('click', '.js-dialog', (event) => {
  const $el = $(event.target);

  const url = $el.attr('data-dialog-url');
  const title = $el.attr('data-dialog-title');
  const handler = dialogEvents.get($el.attr('data-dialog-event'));

  const ajax = { url };

  if (handler) {
    ajax.success = () => {
      window.setTimeout(handler, 0);
    }
  }

  lDialog.open({title, ajax});
});


  // Temporary!
  const open = lDialog.open;
  let scrollTop = 0;

  lDialog.open = function(options) {
    scrollTop = document.body.scrollTop;
    open(options);
  };

  $(_ => {
    $(document).on('click', '.' + lDialog.defaults.Classes.DIALOG_DISMISSAL_ITEM, e => {
      document.body.scrollTop = scrollTop;
    });
  });
